export default __webpack_public_path__ + "static/media/i120jp.b47f2808.webp";